import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import economyReducers from "../reducers"

// Spend credits on a look. The response carries the new balance and the whole catalogue with its
// owned/equipped flags, so the card flips and the balance drops from one answer — nothing has to
// be re-fetched, and there is no moment where the two disagree.
export const thunk = createAsyncThunk(
  "economy/buyCosmetic",
  async ({ cosmetic }, { rejectWithValue }) => {
    try {
      const response = await apiClient.post("/shop/cosmetics/", { cosmetic })
      return { credits: response.data.credits, cosmetics: response.data.cosmetics }
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  }
)

export const onSucceed = economyReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
